<div *ngIf="apiLoaded | async">
    <google-map class="gmapinv"></google-map>
</div>    
<div class="gmap" #map id="map"></div> 

